module.exports = __webpack_public_path__ + "static/media/sidebar-1.61c4c50e.jpg";